import React, { useState } from 'react';

const useInputState = (initState: string) => {
  const [inputState, setInputState] = useState(initState);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    setInputState(e.target.value);
  }

  return [inputState, handleInput] as [string, typeof handleInput];
}

export default useInputState;